import AdminAppBar from './AdminAppBar'
import TemplateList from './TemplateList'
// import { useState } from 'react'
// import { ITemplate } from '../../../types/templates'
// import TemplateEditor from './TemplateEditor'

const copyWelcome =
  ''


/**
 * Custom `TemplateSelector` component declaration.
 * Load AdminAppBar and TemplateList with message welcome
 * @return TemplateSelector
*/
const TemplateSelector = (): JSX.Element => {
  // const [template, setTemplate] = useState<ITemplate | undefined>()
  return (
    <>
      <AdminAppBar />
      {/* {template ? (
        <TemplateEditor template={template} />
      ) : ( */}
        <TemplateList copyWelcome={copyWelcome} />
      {/* )} */}
    </>
  )
}

export default TemplateSelector